export default 'ipfs-pubsub-direct-channel/v1'
